<ion-card class="lucky-slider" (click)="showPreviousExpandView($event); onClick('previous_checks_widget');">
    <div class="trigger-mini-card">
        <img [src]="syndicateData?.previous_checks?.icon_url"
            alt="Icon for the previous check section" />
    </div>
    <div class="prv-mini-title">
        <h5>{{ syndicateData?.previous_checks?.title }}</h5>
    </div>
    @if (previousCheckStatus) {
      <ng-lottie
        [options]="previousCheckOptions"
        class="previous-check-animation"
        (click)="onClick('previous_checks_widget'); showPreviousExpandView($event);"
        (animationCreated)="updateAnimationStatus('previous_checks_widget', previousCheckDuration);"
      ></ng-lottie>
      }
</ion-card>
